import { omit } from 'lodash';
import { v4 } from 'uuid';

import { SEE_ALL__IMAGE_LOCATION } from '@models/Image';
import { DetailedPage } from '@models/Page';
import PageSection, { PageSectionSource, SEE_ALL } from '@models/PageSection';

import { getCopiedLayoutEntity } from './layoutEntityUtils';

export const removeImagesFromPageSection = (section: PageSection): PageSection => ({
  ...section,
  sources: section.sources.map(source => {
    if (source.type !== 'image') return omit(source, 'image');
    if (!source.image) return source;
    const imgSplit = source.image.split('/');
    imgSplit.splice(imgSplit.length - 1, 1, v4());
    return { ...source, image: imgSplit.join('/') };
  }),
});

export const removeImagesFromPage = (page: DetailedPage): DetailedPage => ({
  ...page,
  theme: omit(page.theme, 'backgroundImage'),
  sections: page.sections.map(section => removeImagesFromPageSection(section)),
});

export const copyPage = (page: DetailedPage, removeImages?: boolean) => {
  const copiedPage = getCopiedLayoutEntity(page);
  return removeImages ? removeImagesFromPage(copiedPage) : copiedPage;
};

export const isSeeAllItem = ({ params }: PageSectionSource) => params?.behavior === SEE_ALL;

export const hasSeeAllDefaultImage = ({ image }: PageSectionSource) =>
  image === SEE_ALL__IMAGE_LOCATION;

export const isSeeAllPageWithDefaultImage = (source: PageSectionSource) =>
  isSeeAllItem(source) && hasSeeAllDefaultImage(source);
